import React, { useState, useEffect } from 'react';
import { collection, addDoc, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase/config';
import './Reviews.css';

const Reviews = () => {
  const [reviews, setReviews] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    comment: '',
    rating: 5
  });
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(true);

  // Firebase'den yorumları yükle
  useEffect(() => {
    loadReviews();
  }, []);

  const loadReviews = async () => {
    setLoading(true);
    try {
      const reviewsRef = collection(db, 'reviews');
      const q = query(reviewsRef, orderBy('timestamp', 'desc'));
      const querySnapshot = await getDocs(q);
      const reviewsData = [];
      querySnapshot.forEach((doc) => {
        reviewsData.push({ id: doc.id, ...doc.data() });
      });
      setReviews(reviewsData);
    } catch (error) {
      console.error('Yorumlar yüklenirken hata:', error);
      // Firebase bağlantısı yoksa kullanıcıya bilgi ver
      if (error.code === 'failed-precondition') {
        console.warn('Firebase config eksik veya Firestore kuralları yanlış yapılandırılmış.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.name.trim() && formData.comment.trim()) {
      try {
        const newReview = {
          name: formData.name,
          comment: formData.comment,
          rating: parseInt(formData.rating),
          date: new Date().toISOString().split('T')[0],
          timestamp: new Date()
        };
        
        await addDoc(collection(db, 'reviews'), newReview);
        setFormData({ name: '', comment: '', rating: 5 });
        setShowForm(false);
        alert('Yorumunuz başarıyla eklendi!');
        loadReviews(); // Yorumları yeniden yükle
      } catch (error) {
        console.error('Yorum eklenirken hata:', error);
        alert('Yorum eklenirken bir hata oluştu. Lütfen daha sonra tekrar deneyin.');
      }
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  if (loading) {
    return (
      <div className="reviews">
        <div className="reviews-container">
          <h1 className="reviews-title">Müşteri Yorumları</h1>
          <p className="reviews-subtitle" style={{ color: 'white', textAlign: 'center', marginTop: '2rem' }}>
            Yorumlar yükleniyor...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="reviews">
      <div className="reviews-container">
        <h1 className="reviews-title">Müşteri Yorumları</h1>
        <p className="reviews-subtitle">Öğrencilerimizin deneyimleri</p>

        <button 
          className="add-review-btn"
          onClick={() => setShowForm(!showForm)}
        >
          {showForm ? 'Formu Kapat' : '+ Yorum Ekle'}
        </button>

        {showForm && (
          <form className="review-form" onSubmit={handleSubmit}>
            <h3>Yorumunuzu Paylaşın</h3>
            <div className="form-group">
              <label htmlFor="name">Adınız Soyadınız</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Adınızı girin"
              />
            </div>
            <div className="form-group">
              <label htmlFor="rating">Puanınız</label>
              <select
                id="rating"
                name="rating"
                value={formData.rating}
                onChange={handleChange}
                required
              >
                <option value="5">5 ⭐</option>
                <option value="4">4 ⭐</option>
                <option value="3">3 ⭐</option>
                <option value="2">2 ⭐</option>
                <option value="1">1 ⭐</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="comment">Yorumunuz</label>
              <textarea
                id="comment"
                name="comment"
                value={formData.comment}
                onChange={handleChange}
                required
                rows="5"
                placeholder="Deneyiminizi paylaşın..."
              />
            </div>
            <button type="submit" className="submit-btn">
              Yorumu Gönder
            </button>
          </form>
        )}

        <div className="reviews-list">
          {reviews.length === 0 ? (
            <p className="no-reviews">Henüz yorum yok. İlk yorumu siz yapın!</p>
          ) : (
            reviews.map((review) => (
              <div key={review.id} className="review-card">
                <div className="review-header">
                  <div className="review-author">
                    <div className="author-avatar">
                      {review.name.charAt(0).toUpperCase()}
                    </div>
                    <div>
                      <h4>{review.name}</h4>
                      <span className="review-date">{review.date}</span>
                    </div>
                  </div>
                  <div className="review-rating">
                    {'⭐'.repeat(review.rating)}
                  </div>
                </div>
                <p className="review-comment">{review.comment}</p>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Reviews;

